import {
  cn
} from "./chunk-Q2O3JHTB.js";

// src/checkbox/checkbox.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Checkbox = ({
  className,
  id,
  name,
  outerWrapperClassName,
  innerWrapperClassName,
  label,
  labelClassName,
  ref,
  error,
  required,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs("div", { className: cn(outerWrapperClassName), children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          innerWrapperClassName,
          error && "!text-heritage-red-60 !border-heritage-red-60"
        ),
        children: /* @__PURE__ */ jsxs(
          "label",
          {
            htmlFor: name || id,
            className: cn(
              "label-md bg-heritage-off-white-full",
              error && "!text-heritage-red-60 !border-heritage-red-60",
              labelClassName,
              "input-form-wrapper w-full",
              "!justify-normal"
            ),
            children: [
              /* @__PURE__ */ jsx(
                "input",
                {
                  ref,
                  id: name || id,
                  name,
                  type: "checkbox",
                  className: cn(
                    "focus-visible:outline-none accent-heritage-red-full",
                    className,
                    error && ""
                  ),
                  ...rest
                }
              ),
              label
            ]
          }
        )
      }
    ),
    error && /* @__PURE__ */ jsx("p", { className: "error-message", children: error })
  ] });
};
var checkbox_default = Checkbox;

export {
  checkbox_default
};
